<template>
  <v-row justify="center">
    <v-dialog
      :value="cajaModal"
      persistent
      :max-width="cajaModalType == 'corte'?600:450"
    >
      <CorteCaja v-if="cajaModalType == 'corte'" @close-caja-modal="closeModal" @done-corte-caja="delegateToParent"/>
      <FondoCaja v-else-if="cajaModalType =='fondo'" @close-caja-modal="closeModal" @new-fondo-added="delegateToParent"/>
      <CajaInput v-else :cajaInputType="cajaModalType" @close-caja-modal="closeModal" @new-movimiento-added="delegateToParent"/>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CorteCaja from './CorteCaja';
import FondoCaja from './FondoCaja';
import CajaInput from './CajaInput';

export default {
  name: 'CajaModal',
  components: {
    CorteCaja,
    FondoCaja,
    CajaInput,
  },
  computed: {
    ...mapGetters(['cajaModal', 'cajaModalType']),
  },
  methods:{
    ...mapActions(['closeCajaModal']),
    closeModal(){
      this.closeCajaModal(false);
    },
    delegateToParent(){
      this.$emit('refresh-caja-content');
    }
  }
}
</script>